import { SortDirection } from "../models/sortDirection";
import { PageQuery } from "../models/pageQuery";
import { FilterBy } from "../models/filterBy";
import { nameOf } from "../../functions/nameof";
import { Form } from "../../entities/form";

export function getInitialQuery(queryParams: URLSearchParams): PageQuery {
    const filterByArray = queryParams.getAll("filterBy");
    const filterOnArray = queryParams.getAll("filterOn");

    function getFilters(filterOn: string[], filterBy: string[]) {
        const filter: FilterBy[] = [];
        for (let i = 0; i < filterBy.length; i++) {
            filter.push({
                value: filterOnArray[i],
                field: filterByArray[i]
            });
        }
        return filter;
    }

    return {
        filterBy: filterByArray ? getFilters(filterOnArray, filterByArray) : [],
        sortBy: {
            field:
                queryParams.get("sortByField") ??
                nameOf<Form>((x) => x.createdAt),
            direction: queryParams.has("sortDirection")
                ? (queryParams.get("sortDirection") as SortDirection)
                : SortDirection.DESC
        },
        searchTerm: queryParams.get("searchTerm")!,
        page: {
            size: 20,
            index: 0
        }
    } as PageQuery;
}
